export default __webpack_public_path__ + "static/media/laundry1-afterA-2048w.920b777e.webp";